module.exports = __webpack_public_path__ + "static/media/preview-thumbnail-4.035a4b37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pseudodocs/preview-thumbnail-4.jpg
// module id = 1890
// module chunks = 2